import { montserratNormal, montserratSemibold } from '@/assets/fonts/montserrat'
import React, { useEffect, useState } from 'react'
import image1 from "@/assets/tax/1.png"
import image2 from "@/assets/tax/2.png"
import image3 from "@/assets/tax/3.png"
import image4 from "@/assets/tax/4.png"
import image1En from "@/assets/tax/1-en.png"
import image2En from "@/assets/tax/2-en.png"
import image3En from "@/assets/tax/3-en.png"
import image4En from "@/assets/tax/4-en.png"
import image1mobile from "@/assets/tax/1-mobile.png"
import image2mobile from "@/assets/tax/2-mobile.png"
import image3mobile from "@/assets/tax/3-mobile.png"
import image4mobile from "@/assets/tax/4-mobile.png"
import Image from 'next/image'
import { t } from 'i18next'
import { getCookie } from 'cookies-next'


export default function TaxServices({lang}) {

  const [language, setLanguage] = useState("id")

  useEffect(() => {
    setLanguage(lang)
  }, [lang])
  

  return (
    <div className='flex flex-col justify-center items-center w-full max-w-[1280px] lg:mx-auto lg:container px-4 lg:px-8 lg:py-16'>
      <div className='flex justify-center items-center flex-col w-full'>
        <h1 className={`${montserratSemibold.className} leading-[44px] text-[36px] text-gray-cool-700 pb-4`}>{t('tax_service_title')}</h1>
        <p className={`${montserratNormal.className} text-gray-cool-500 `}>{t('tax_service_description')}</p>
      </div>
      <div className='grid w-full gap-8 lg:gap-16 py-16 grid-cols-1 md:grid-cols-2'>
        <div className="flex justify-center items-center flex-col">
          <div className="md:hidden flex relative">
            <Image src={image1mobile} />
          </div>
          <div className="md:flex hidden relative">
            <Image src={language != 'id' ? image1En : image1} />
          </div>
          <div className='flex flex-col'>
            <p className={`${montserratNormal.className} text-[20px] text-gray-cool-700 py-4 pb-2`}>{t('tax_service_card_title_1')}</p>
            <p className={`${montserratNormal.className} text-[16px] text-gray-cool-500`}>{t('tax_service_card_description_1')}</p>
          </div>
        </div>
        <div className="flex justify-center items-center flex-col">
          <div className="md:hidden flex relative">
            <Image src={image2mobile} />
          </div>
          <div className="md:flex hidden relative">
          <Image src={language != 'id' ? image2En : image2} />
          </div>
          <div className='flex flex-col'>
            <p className={`${montserratNormal.className} text-[20px] text-gray-cool-700 py-4 pb-2`}>{t('tax_service_card_title_2')}</p>
            <p className={`${montserratNormal.className} text-[16px] text-gray-cool-500`}>{t('tax_service_card_description_2')}</p>
          </div>
        </div>
        <div className="flex relative flex-col">
          <div className="md:hidden flex relative">
            <Image src={image3mobile} />
          </div>
          <div className="md:flex hidden relative">
          <Image src={language != 'id' ? image3En : image3} />
          </div>
          <div className='flex flex-col'>
            <p className={`${montserratNormal.className} text-[20px] text-gray-cool-700 py-4 pb-2`}>{t('tax_service_card_title_3')}</p>
            <p className={`${montserratNormal.className} text-[16px] text-gray-cool-500`}>{t('tax_service_card_description_3')}</p>
          </div>
        </div>
        <div className="flex justify-center items-center flex-col">
          <div className="md:hidden flex relative">
            <Image src={image4mobile} />
          </div>
          <div className="md:flex hidden relative">
            <Image src={language != 'id' ? image4En : image4} />
          </div>
          <div className='flex flex-col'>
            <p className={`${montserratNormal.className} text-[20px] text-gray-cool-700 py-4 pb-2`}>{t('tax_service_card_title_4')}</p>
            <p className={`${montserratNormal.className} text-[16px] text-gray-cool-500`}>{t('tax_service_card_description_4')}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
